module.exports = __webpack_public_path__ + "img/fact_check_outlined.391d49dd.svg";